const API_BASE = (process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8001/api').replace(/\/$/, '')

export async function apiFetch(
  url: string,
  options: RequestInit = {}
) {

  let res = await fetch(url, {
    ...options,
    credentials: "include"
  })

  if (res.status !== 401) {
    return res
  }

  // attempt refresh
  const refresh = await fetch(
    `${API_BASE}/auth/refresh/`,
    {
      method: "POST",
      credentials: "include"
    }
  )

  if (!refresh.ok) {

    // session expired
    //window.location.href = "/fr/auth/sign-in"

    throw new Error("Session expired")
  }

  // retry original request

  res = await fetch(url, {
    ...options,
    credentials: "include"
  })

  return res
}